import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login'
Vue.use(Router)
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login,
    },
    {
      path: '/',
      name: 'Index',
      component: index,
      redirect: 'login',
      children: [
        {
          // 首页
          path: 'home',
          name: 'Home',
          component: () => import('../views/home/home.vue'),
        },
        {

          path: 'orgAdmin',
          name: 'orgAdmin',
          component: () => import('../views/org/orgAdmin.vue'),
        },
        {

          path: 'mchAdmin',
          name: 'mchAdmin',
          component: () => import('../views/mch/mchAdmin.vue'),
        },
        {

          path: 'elabelAdmin',
          name: 'elabelAdmin',
          component: () => import('../views/elabel/elabelAdmin.vue'),
        },
        {

          path: 'elabelTempCtm',
          name: 'elabelTempCtm',
          component: () => import('../views/mch/elabelTemp/elabelTempCtm.vue'),
        },
        {

          path: 'templateList',
          name: 'templateList',
          component: () => import('../views/template/templateList.vue'),
        },
       // {
       //
       //   path: 'elabelTemp',
       //   name: 'elabelTemp',
       //   component: () => import('../views/jc/elabelTemp.vue'),
       // },
       // {

       //   path: 'elabelTemp',
       //   name: 'elabelTemp',
       //   component: () => import('../views/jc/custom/index.vue'),
       // },

      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js